/**
 * Meilisearch Request Tracker
 *
 * Tracks ALL Meilisearch search requests (single and multi) by index.
 * Separate from SearchStatsTracker which tracks explicit user search queries.
 * Uses fire-and-forget approach to avoid impacting user experience.
 */

/**
 * Track a single Meilisearch search request
 *
 * @param {Object} options
 * @param {number} options.tenantId - The tenant ID
 * @param {string} options.index - The Meilisearch index name
 * @param {string} options.source - 'single' or 'multi'
 */
export function trackMeilisearchRequest({ tenantId, index, source = 'single' }) {
    if (!tenantId || !index) return;

    fetch('/api/track-ms-request', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            tenant_id: tenantId,
            index: index,
            source: source,
        }),
    }).catch(() => {
        // Silently ignore errors - tracking should never break the app
    });
}

/**
 * Track multiple indexes from a multi-search request
 *
 * @param {Object} options
 * @param {number} options.tenantId - The tenant ID
 * @param {Array<string>} options.indexes - Array of index names queried
 */
export function trackMultiSearchRequests({ tenantId, indexes }) {
    if (!tenantId || !indexes?.length) return;

    for (const index of indexes) {
        trackMeilisearchRequest({ tenantId, index, source: 'multi' });
    }
}
